export default {
  "userReport.tooltip.copy.userno": "Copy UserNo: {text}",
  "userReport.tooltip.showUserDetails": "Show User Details",
  "userReport.thead.userno": "UserNo",
  "userReport.thead.statisticsTime": "StatisticsTime",
  "userReport.thead.statisticsTimeFrom": "StartTime",
  "userReport.thead.statisticsTimeTo": "EndTime",
  "userReport.thead.statisticsType": "StatisticsType",
  "userReport.thead.gameType": "GameType",
  "userReport.thead.whatsapp": "Whatsapp",
  "userReport.thead.channel": "Channel",
  "userReport.thead.depositFee": "DepositFee",
  "userReport.thead.depositAmountFeeDiff": "DepositAmountFeeDiff",
  "userReport.thead.depositAmount": "DepositAmount ",
  "userReport.thead.withdrawFee": "WithdrawFee",
  "userReport.thead.withdrawAmountFeeDiff": "WithdrawAmountFeeDiff",
  "userReport.thead.withdrawAmount": "WithdrawAmount",
  "userReport.thead.depositWithdrawDiff": "Deposit-Withdraw",
  "userReport.thead.depositWithdrawFeeDiff": "DepositWithdrawFeeDiff",
  "userReport.thead.betAmount": "BetAmount",
  "userReport.thead.realBetAmount": "RealBetAmount",
  "userReport.thead.winBetAmountDiff": "WinBetAmountDiff",
  "userReport.thead.promotionAmount": "PromotionAmount",
  "userReport.thead.cashbackAmount": "CashbackAmount",
  "userReport.thead.bonusAmount": "BonusAmount",
  "userReport.thead.adminAmount": "AdminAmount",
  "userReport.thead.balanceAmount": "BalanceAmount",
  "userReport.thead.balanceSubAmount": "BalanceSubAmount",
  "userReport.thead.gainAmount": "GainAmount",
  "userReport.thead.reportUpdateTime": "ReportTime",
};
